export default "__VITE_ASSET__VBAEho46__"